import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled, { css } from "styled-components";
import { getLocale } from "react-i18nify";

import * as MatStyled from "@mui/material/styles";
import {
  Grid,
  Stack,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  IconButton,
  Box,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
// import TextField from "@mui/material/TextField";

import CloseIcon from "@mui/icons-material/Close";
import AddCircleIcon from "@mui/icons-material/AddCircle";
// import FileDownloadIcon from "@mui/icons-material/FileDownloadOutlined";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

// import { updateStatusOrder } from "src/api/order";
import { cancelOrder, getLalamoveOrderInfo } from "src/api/lalamove";
import { getOrderDetailBySeller } from "src/api/sellerOrder";

import { device } from "src/styles/device";
import font from "src/styles/font";
import { serviceType } from "src/common/lalamove";
import { statusOrderColor } from "src/common/color";
import { checkNotEmpty } from "src/common";
import {
  Black,
  Blue,
  Green,
  Primary,
  Red,
  White,
  White01,
  Yellow,
} from "src/styles/color";
import { useDialog } from "src/context/DialogContext";
// import useDeviceSize from "src/hooks/useDeviceSize";
import useModal from "src/hooks/useModal";

import Button from "src/components/core/Button";
import Loading from "src/components/ui/Loading";
import UploadImage from "src/components/upload/dropzone/UploadImage";
// import PreviewDialog from "src/modules/promo-code/PreviewDialog";
// import GetQuotationDialog from "src/components/order/GetQuotationDialog";
import GetQuotationDialog from "src/components/order/GetQuotationModal";
import { updateSellerSelfDelivery } from "src/api/order";
import { useSnackbar } from "notistack";

const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  // padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
  marginTop: "75px",
  height: "calc(100vh - 75px)",
  overflow: "hidden",
  overflowY: "scroll",
  [theme.breakpoints.down("sm")]: {
    marginTop: "64px",
    height: "calc(100vh - 64px)",
  },
}));

const Container = styled.div`
  width: 100%;
  max-width: 1240px;
  position: relative;
  padding: 24px 70px 80px;
  margin: auto;
  /* background: ${White01}; */

  & > div > p {
    word-wrap: break-word;
  }

  @media ${device.laptop} {
    padding: 24px 40px 80px;
  }
  @media ${device.tabletL} {
    padding: 24px 0 60px;
  }
  @media ${device.mobileL} {
    padding: 16px 0 40px;
  }
`;

const SpanTitle = styled.span`
  color: ${Black};
  font-size: 1.125rem;
  font-weight: 500;
  /* margin-bottom: 16px; */

  @media ${device.tabletL} {
    font-size: 1rem;
  }
  /* @media ${device.mobileL} {
    font-size: 0.875rem;
  } */
`;

const WrapperHeaderFixed = styled.div`
  width: 100%;
  /* max-width: 1240px; */
  position: sticky;
  top: 0;
  background-color: #ffffff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  z-index: 100;
`;

const HeaderFixed = styled.div`
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 16px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  @media ${device.tabletL} {
    padding: 16px 40px;
  }
  @media ${device.mobileL} {
    padding: 16px 24px;
    gap: 8px;
  }
`;

const HeaderItem = styled.div`
  width: max-content;
  display: flex;
  align-items: center;
  gap: 24px;

  @media ${device.tabletL} {
    gap: 8px;
    flex-direction: ${({ flexDirection }) => flexDirection && flexDirection};
    align-items: ${({ flexDirection }) =>
      flexDirection === "row" ? "center" : "flex-start"};
  }
  /* @media ${device.mobileL} {
    gap: 8px;
  } */
`;

const DivDetailBackground = styled.div`
  width: 100%;
  padding: 40px;
  background-color: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 24px;
  /* margin: 16px 0; */

  @media ${device.tabletL} {
    box-shadow: unset;
    border-radius: 0;
    border-bottom: 10px var(--darkwhite-color) solid;
    padding: 16px 40px 24px;
  }
  @media ${device.mobileL} {
    padding: 16px 24px 24px;
  }
`;

const DivBackground = styled.div`
  width: 100%;
  padding: 24px;
  background-color: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 16px;
  /* margin: 16px 0; */

  @media ${device.tabletL} {
    box-shadow: unset;
    border-radius: 0;
    padding: 0 40px 24px;
    border-bottom: 10px var(--darkwhite-color) solid;
  }
  @media ${device.mobileL} {
    padding: 0 24px 24px;
  }
`;

const SpanSubHeader = styled.p`
  color: rgb(106 106 109);
  font-size: 0.75rem;
  font-weight: 400;
  margin-bottom: 8px;
  margin-top: 0;
`;

const SpanContent = styled.p`
  min-height: 40px;
  color: ${Black};
  font-size: 1rem;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
  background: ${White01};
  padding: 8px 16px;
  border-radius: 8px;

  @media ${device.mobileL} {
    font-size: 0.875rem;
  }
`;

const DivProductTitle = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const DivProductHeader = styled.div`
  width: 100%;
  margin-top: 24px;
`;

const WrapperProductHeader = styled.div`
  flex-direction: row;
  padding: 16px;
  display: flex;
  background: #f3f1f2;
`;

const DivProduct = styled.div`
  width: 100%;
`;

const WrapperProduct = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 5px 0;
  margin-left: 10px;

  &:not(:last-child) {
    border-bottom: 1px solid #d9d9d9;
    padding-bottom: 20px;
  }
  &:not(:first-child) {
    padding-top: 20px;
  }
`;

const WrapperProductImage = styled.div`
  width: 80px;
  min-width: 80px;
  height: 80px;
  margin: 16px;
  /* flex: 1; */

  @media ${device.mobileL} {
    width: 60px;
    min-width: 60px;
    height: 60px;
    margin: 0;
    margin-top: 16px;
  }
`;

const ImgProduct = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 16px;
`;

const WrapperDesc = styled.div`
  width: 50%;
  display: block;
  margin: auto;
  overflow: hidden;

  @media ${device.mobileL} {
    width: 65%;
    margin: 0;
    margin-left: auto;
    margin-top: 16px;
  }
`;

const ProductName = styled.p`
  font-size: 1rem;
  /* width: 80%; */
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${device.mobileL} {
    margin: 0;
    font-size: 0.875rem;
  }
`;

const ProductCode = styled.p`
  font-size: 0.75rem;
  /* width: 80%; */
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${device.mobileL} {
    margin: 8px 0;
  }
`;

const ProductType = styled.p`
  font-size: 0.75rem;
  font-weight: 400;
  /* width: 80%; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${device.mobileL} {
    margin: 8px 0;
  }
`;

const WrapperProductField = styled.div`
  // margin-bottom: 16px;
  margin: auto;
  display: flex;
  justify-content: center;
  width: 65%;
`;

const LabelTitle = styled.div`
  font-size: 1.125rem;
  font-weight: 500;
  color: ${Black};
  width: 100%;
  margin-bottom: 24px;

  @media ${device.tabletL} {
    font-size: 1rem;
  }
`;

const Price = styled.p`
  margin: 0;
  color: ${(props) => (props.fontColor ? props.fontColor : "#252525")};
  font-size: 1rem;
  font-weight: ${(props) => (props.bold ? 600 : 400)};
  text-align: ${(props) => (props.align ? props.align : "left")};

  ${({ desc }) =>
    desc &&
    css`
      span {
        font-size: 1rem;
        font-weight: 400;
        color: ${Black};
        text-decoration: underline;
        margin-left: 10px;
        cursor: pointer;
      }
    `}

  @media ${device.tabletL} {
    font-size: 0.875rem;
  }
`;

const WrapperDeliveryDetail = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  &:not(:last-child) {
    margin-bottom: 16px;
  }
`;

const WrapperDeliveryType = styled.div`
  width: 100%;
  padding: 8px 16px;
  background: ${White01};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  @media ${device.mobileL} {
    padding: 8px;
  }
`;

const SpanDeliverType = styled.p`
  margin: 0;
  color: ${Black};
  font-size: 1rem;
  font-weight: ${({ price }) => (price ? 500 : 400)};
  line-height: 24px;

  @media ${device.tabletL} {
    font-size: 0.875rem;
  }
`;

const SpanDeliverStatus = styled.p`
  margin: 0;
  color: ${({ delivery, success, cancel }) =>
    delivery ? Blue : success ? Green : cancel ? Red : Yellow};
  font-size: 1rem;
  font-weight: 400;
  line-height: 24px;
  text-decoration: ${({ link }) => (link ? "underline" : "none")};

  @media ${device.tabletL} {
    font-size: 0.875rem;
  }
`;

const WrapperAttachSlip = styled.div`
  width: 100%;
  max-width: 350px;
  height: auto;
  min-height: 350px;
  margin: 24px auto;
  background: #ffffff;
  border: 1px dashed #d9d9d9;
  border-radius: 24px;
  position: relative;
  /* display: flex;
  justify-content: center;
  align-items: center; */
`;

const SpanAttachSlip = styled.span`
  position: absolute;
  top: -10px;
  left: 12px;
  font-size: 0.75rem;
  font-weight: 400;
  color: #6c6c70;
  padding: 0 4px;
  background: #ffffff;
`;

const WrapperUploadImage = styled.div`
  width: 100%;
  max-width: 350px;
  min-height: 350px;
  padding: 10px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const WrapperImgSlip = styled.div`
  width: 100%;
  max-width: 300px;
  height: auto;
`;

const ImgSlip = styled.img`
  width: 100%;
  height: 100%;
  /* max-height: 300px; */
  object-fit: contain;
`;

const WrapperConfirmButton = styled.div`
  width: 100%;
  /* margin: 30px auto 0; */
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

function SellerOrderDetail({ open }) {
  let { orderId } = useParams();

  const { enqueueSnackbar } = useSnackbar();
  const { getModalState, open: openState, close } = useModal();
  const { openDialog, closeDialog, closeAllDialogs } = useDialog();

  const initialUpdate = {
    _id: orderId,
    status: "",
    delivery_sending_image: null,
  };
  const [updateOrder, setUpdateOrder] = useState(initialUpdate);
  const [orderDetail, setOrderDetail] = useState({});
  const [deliveryType, setDeliveryType] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (orderId === undefined) return;

    fetchOrderDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  const fetchOrderDetail = async () => {
    try {
      setIsLoading(true);
      await getOrderDetailBySeller(orderId)
        .then(async ({ data }) => {
          let delivery_group = data?.delivery_detail_group;

          if (!!data?.delivery_detail_group?.delivery_ref_code) {
            const { data: resData } = await getLalamoveOrderInfo(
              data?.delivery_detail_group?.delivery_ref_code,
            );

            delivery_group = {
              ...data?.delivery_detail_group,
              delivery_ref_code: resData.data,
            };
          }

          if (!!data?.delivery_detail_group?.delivery_type) {
            setDeliveryType(
              data?.delivery_detail_group?.delivery_type?.type_en,
            );
          }

          setOrderDetail({
            ...data,
            order_ref_pays: data?.order_ref_pays ?? [],
            delivery_detail_group: delivery_group,
          });
          setUpdateOrder((info) => ({
            ...info,
            status: data?.status,
          }));
        })
        .catch((err) => {
          console.error("err", err);
          // navigate("/404");
        });
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const convertPrice = (price) =>
    Intl.NumberFormat("th-TH", {
      style: "currency",
      currency: "THB",
    }).format(price);

  useEffect(() => {
    if (isLoading) document.body.style.overflow = "hidden";
    else document.body.style = "none";
  }, [isLoading]);

  const handleUpdate = async () => {
    try {
      setIsLoading(true);
      await updateSellerSelfDelivery({
        order_id: updateOrder?._id,
        delivery_sending_image: updateOrder?.delivery_sending_image,
      });

      await enqueueSnackbar("อัปเดตสำเร็จ", {
        variant: "success",
      });

      await fetchOrderDetail();
    } catch (err) {
      console.error("err: ", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelLalamove = async () => {
    try {
      setIsLoading(true);

      await cancelOrder(
        orderDetail?.delivery_detail_group?.delivery_ref_code?.orderId,
      );

      await enqueueSnackbar(`ยกเลิกการเรียกรถสำเร็จ`, {
        variant: "success",
        autoHideDuration: 2000,
      });

      window.location.reload();
    } catch (err) {
      console.error(err);
      enqueueSnackbar(err[0].message, {
        variant: "error",
        autoHideDuration: 2000,
      });
      window.location.reload();
    } finally {
      setIsLoading(false);
    }
  };

  const ProductOrder = () => {
    return orderDetail?.product_choice_orders?.map((product, index) => {
      return (
        <WrapperProduct key={`order-product-${index}`}>
          <Grid item xs={6} sx={{ display: "flex" }}>
            <WrapperProductImage>
              <ImgProduct
                src={product?.product_choice_order?.group_image?.product_display_image.replace(
                  ".com",
                  ".com/300x300",
                )}
                alt={
                  product?.product_choice_order?.group_image
                    ?.product_display_image
                }
              />
            </WrapperProductImage>

            <WrapperDesc>
              <ProductName>
                {product?.product_choice_order?.product?.item_name}
              </ProductName>

              <ProductCode>
                {product?.product_choice_order?.product?.item_code}
              </ProductCode>

              <ProductType>
                {product?.product_choice_order?.name || "-"}
              </ProductType>
            </WrapperDesc>
          </Grid>

          <Grid item xs={6} sx={{ display: "flex", pr: 2 }}>
            <WrapperProductField>
              <ProductName style={{ textAlign: "center" }}>
                {product?.volume ? product?.volume : 0}
              </ProductName>
            </WrapperProductField>
          </Grid>
        </WrapperProduct>
      );
    });
  };

  return (
    <>
      <Main open={open}>
        <WrapperHeaderFixed>
          <HeaderFixed>
            <HeaderItem flexDirection="column">
              <SpanTitle>
                {getLocale() === "th" ? "รายละเอียดใบสั่งซื้อ" : "Order detail"}
              </SpanTitle>
            </HeaderItem>

            <HeaderItem flexDirection="row">
              <SpanTitle>
                {getLocale() === "th" ? "สถานะ" : "Status"} :
              </SpanTitle>
              <FormControl
                sx={{
                  minWidth: {
                    sm: 200,
                    xs: 140,
                  },
                  alignSelf: "flex-end",
                }}
              >
                <Select
                  labelId="status-select-label"
                  id="status-select"
                  value={updateOrder.status}
                  // label={getLocale() === "th" ? "สถานะ" : "Status"}
                  sx={{
                    ...statusOrderColor(updateOrder),
                    ".MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input":
                      {
                        padding: {
                          md: `16px 14px`,
                          xs: `8px 12px`,
                        },
                        paddingRight: {
                          md: 4,
                          xs: 3,
                        },
                        fontSize: {
                          md: "1rem",
                          xs: "0.875rem",
                        },
                      },
                    ".Mui-disabled, &.Mui-disabled .MuiOutlinedInput-notchedOutline, &.MuiSelect-icon.Mui-disabled":
                      {
                        color: "transparent",
                        WebkitTextFillColor: White,
                        borderColor: "transparent",
                      },
                  }}
                  disabled={true}
                >
                  <MenuItem value={"wp"}>รอจ่ายเงิน</MenuItem>
                  <MenuItem value={"ordered"}>จ่ายเงินสำเร็จ</MenuItem>
                  <MenuItem value={"ordered"}>จ่ายเงินสำเร็จ</MenuItem>
                  <MenuItem value={"in progress"}>กำลังดำเนินการ</MenuItem>
                  <MenuItem value={"delivery"}>ส่งของ</MenuItem>
                  <MenuItem value={"wc"}>รอการยืนยัน</MenuItem>
                  <MenuItem value={"refund"}>คืนเงิน</MenuItem>
                  <MenuItem value={"cancel"}>ยกเลิก</MenuItem>
                  <MenuItem value={"success"}>สำเร็จ</MenuItem>
                </Select>
              </FormControl>
            </HeaderItem>
          </HeaderFixed>
        </WrapperHeaderFixed>

        <Container>
          <Grid
            container
            spacing={{
              md: 4,
              xs: 3,
            }}
          >
            {/* Order Detail */}
            <Grid item xs={12} sx={{ margin: "0 auto" }}>
              <DivDetailBackground>
                <Grid
                  container
                  spacing={{
                    md: 4,
                    sm: 4,
                    xs: 2,
                  }}
                >
                  <Grid item md={6} xs={12}>
                    <SpanSubHeader>
                      {getLocale() === "th" ? "เลขที่เอกสาร" : "Document No."}
                    </SpanSubHeader>
                    <SpanContent>{orderDetail?.running_number}</SpanContent>
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <SpanSubHeader>ที่อยู่</SpanSubHeader>
                    <SpanContent>
                      {`
                      ${orderDetail?.shipping_address?.address || ""} ${
                        orderDetail?.shipping_address?.subdistrict || ""
                      } 
                      ${orderDetail?.shipping_address?.district || ""} ${
                        orderDetail?.shipping_address?.province || ""
                      } 
                      ${orderDetail?.shipping_address?.zipcode || ""}
                      `}
                    </SpanContent>
                  </Grid>

                  {orderDetail?.tax_invoice_address?.type === "company" &&
                    orderDetail?.tax_invoice_address?.company_name !== "" && (
                      <>
                        <Grid item xs={6}>
                          <SpanSubHeader>ชื่อบริษัท</SpanSubHeader>
                          <SpanContent>
                            {orderDetail?.tax_invoice_address?.company_name
                              ? orderDetail?.tax_invoice_address?.company_name
                              : "-"}
                          </SpanContent>
                        </Grid>

                        <Grid item xs={6}>
                          <SpanSubHeader>สาขา</SpanSubHeader>
                          <SpanContent>
                            {orderDetail?.tax_invoice_address?.branch
                              ? orderDetail?.tax_invoice_address?.branch
                              : "-"}
                          </SpanContent>
                        </Grid>
                      </>
                    )}
                </Grid>
              </DivDetailBackground>
            </Grid>

            {/* Order summary Section */}
            <Grid item xs={12}>
              <DivBackground>
                <Grid container spacing={{ sm: 3, xs: 2 }}>
                  {/* Order Product */}
                  <Grid item xs={12}>
                    <DivProductTitle>
                      <SpanTitle>
                        {getLocale() === "th"
                          ? "สินค้าในใบสั่งซื้อนี้"
                          : "สินค้าในใบสั่งซื้อนี้"}
                      </SpanTitle>
                    </DivProductTitle>

                    <DivProductHeader>
                      <WrapperProductHeader>
                        <Grid
                          item
                          xs={6}
                          sx={{
                            margin: "auto",
                            // textAlign: "center",
                            fontSize: {
                              sm: "1rem",
                              xs: "0.875rem",
                            },
                            fontWeight: 500,
                          }}
                        >
                          {getLocale() === "th" ? "สินค้า" : "Product"}
                        </Grid>

                        <Grid
                          item
                          xs={6}
                          sx={{
                            margin: "auto",
                            textAlign: "center",
                            fontSize: {
                              sm: "1rem",
                              xs: "0.875rem",
                            },
                            fontWeight: 500,
                          }}
                        >
                          {getLocale() === "th" ? "จำนวน" : "Quantity"}
                        </Grid>
                      </WrapperProductHeader>
                    </DivProductHeader>

                    <DivProduct>{ProductOrder()}</DivProduct>
                  </Grid>
                </Grid>
              </DivBackground>
            </Grid>

            {/* Delivery lalamove */}
            <Grid item xs={12}>
              <DivBackground>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  flexWrap="wrap"
                  sx={{
                    mb: {
                      md: 3,
                      xs: 2,
                    },
                  }}
                >
                  <LabelTitle style={{ margin: 0, width: "max-content" }}>
                    รายละเอียดการขนส่งสินค้า
                  </LabelTitle>

                  {/* <Button
                    onClick={() => {}}
                    variant="text"
                    startIcon={<FileDownloadIcon />}
                    sx={{
                      padding: {
                        sm: "8px 24px",
                        xs: "8px 12px",
                      },
                    }}
                  >
                    {deviceWidth > 540 ? `ดาวน์โหลดใบส่งของ` : `ใบส่งของ`}
                  </Button> */}
                </Stack>

                <WrapperDeliveryDetail>
                  <SpanDeliverType>ประเภทรถขนส่ง</SpanDeliverType>

                  <WrapperDeliveryType>
                    {!!orderDetail?.delivery_detail_group?.delivery_ref_code ? (
                      <>
                        {!!orderDetail?.delivery_detail_group
                          ?.delivery_service_type ? (
                          <Stack gap={1} direction="row" alignItems="center">
                            <Box
                              sx={{
                                width: "30px",
                                height: "30px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <img
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  objectFit: "cover",
                                  objectPosition: "center",
                                  borderRadius: "8px",
                                }}
                                src={`https://xsurface-images.s3.ap-southeast-1.amazonaws.com/lalamove-icon/${orderDetail?.delivery_detail_group?.delivery_service_type}.png`}
                                alt={`${orderDetail?.delivery_detail_group?.delivery_service_type}-img`}
                              />
                            </Box>

                            <SpanDeliverType>
                              {serviceType(
                                orderDetail?.delivery_detail_group
                                  ?.delivery_service_type,
                              )}
                            </SpanDeliverType>
                          </Stack>
                        ) : (
                          <SpanDeliverType>-</SpanDeliverType>
                        )}

                        <Price>
                          {convertPrice(
                            orderDetail?.delivery_detail_group
                              ?.delivery_ref_code?.priceBreakdown?.total,
                          )}
                        </Price>
                      </>
                    ) : !!orderDetail?.delivery_detail_group
                        ?.delivery_sending_image ||
                      orderDetail?.delivery_detail_group?.delivery_type
                        ?.type_en === "By seller" ? (
                      <SpanDeliverType>จัดส่งโดยร้านค้า</SpanDeliverType>
                    ) : (
                      <SpanDeliverType>-</SpanDeliverType>
                    )}
                  </WrapperDeliveryType>
                </WrapperDeliveryDetail>

                <WrapperDeliveryDetail>
                  <SpanDeliverType>สถานะการขนส่ง</SpanDeliverType>

                  <Stack
                    direction={{ xs: "column", md: "row" }}
                    rowGap={1}
                    justifyContent="space-between"
                  >
                    {!!orderDetail?.delivery_detail_group?.delivery_ref_code ? (
                      <a
                        href={
                          orderDetail?.delivery_detail_group
                            ?.delivery_tracking_link
                        }
                        target="_blank"
                        rel="noreferrer"
                      >
                        <SpanDeliverStatus link>
                          {
                            orderDetail?.delivery_detail_group
                              ?.delivery_ref_code?.orderId
                          }
                        </SpanDeliverStatus>
                      </a>
                    ) : orderDetail.status === "delivery" &&
                      !!orderDetail?.delivery_detail_group
                        ?.delivery_sending_image ? (
                      <SpanDeliverStatus delivery>
                        กำลังจัดส่ง
                      </SpanDeliverStatus>
                    ) : updateOrder.status === "wc" ||
                      updateOrder.status === "success" ? (
                      <SpanDeliverStatus success>
                        จัดส่งสำเร็จ
                      </SpanDeliverStatus>
                    ) : updateOrder.status === "cancel" ? (
                      <SpanDeliverStatus cancel>ยกเลิก</SpanDeliverStatus>
                    ) : (
                      <SpanDeliverStatus>กำลังเตรียมสินค้า</SpanDeliverStatus>
                    )}

                    {!!orderDetail?.delivery_detail_group?.delivery_ref_code &&
                      orderDetail?.delivery_detail_group?.delivery_status ===
                        "ready to ship" && (
                        <Button
                          onClick={() =>
                            openDialog({
                              type: "confirm",
                              title: `คุณต้องการยกเลิกการเรียกรถใช่หรือไม่`,
                              onConfirm: () => {
                                handleCancelLalamove();
                                closeDialog();
                              },
                              maxWidth: 342,
                            })
                          }
                          variant="secondary"
                          startIcon={<LocalShippingIcon />}
                          sx={{ width: "max-content", alignSelf: "center" }}
                        >
                          ยกเลิกการเรียกรถ
                        </Button>
                      )}
                  </Stack>
                </WrapperDeliveryDetail>

                {!!!orderDetail?.delivery_detail_group?.delivery_ref_code &&
                  !!!orderDetail?.delivery_detail_group
                    ?.delivery_sending_image && (
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{
                        mb: 3,
                        mt: 3,
                      }}
                    >
                      <FormControl sx={{ width: "100%" }}>
                        <FormLabel
                          required
                          id="delivery-type-radio-group-label"
                          sx={{
                            fontSize: {
                              md: font.size.md,
                              xs: "0.875rem",
                            },
                            color: Black,
                            mb: 1,
                            span: {
                              color: Primary,
                            },
                            "&.Mui-focused": {
                              color: Black,
                            },
                          }}
                        >
                          ช่องทางการขนส่ง
                        </FormLabel>

                        <RadioGroup
                          row
                          aria-labelledby="delivery-type-radio-group-label"
                          name="delivery-type-radio-group"
                          value={deliveryType}
                          onChange={(e) => setDeliveryType(e.target.value)}
                          sx={{
                            ".MuiFormControlLabel-label": {
                              fontSize: {
                                md: font.size.md,
                                xs: "0.875rem",
                              },
                            },
                          }}
                        >
                          <FormControlLabel
                            value="By seller"
                            sx={{
                              width: "100%",
                              m: 0,
                              "&.MuiRadio-root": {
                                width: "auto",
                              },
                              ".MuiFormControlLabel-label.Mui-disabled": {
                                color: Black,
                              },
                            }}
                            disabled={
                              updateOrder.status === "delivery" ||
                              updateOrder.status === "wc" ||
                              updateOrder.status === "success" ||
                              updateOrder.status === "cancel"
                            }
                            control={
                              <Radio
                                sx={{
                                  fontSize: font.size.md,
                                  color: "var(--primary-color)",
                                  "&.Mui-checked": {
                                    color: "var(--primary-color)",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: 22,
                                  },
                                }}
                              />
                            }
                            label="ผู้ขายส่งของเอง"
                          />

                          <FormControlLabel
                            value="LALAMOVE"
                            sx={{
                              width: "100%",
                              m: 0,
                              "&.MuiRadio-root": {
                                width: "auto",
                              },
                              ".MuiFormControlLabel-label.Mui-disabled": {
                                color: Black,
                              },
                            }}
                            disabled={
                              updateOrder.status === "delivery" ||
                              updateOrder.status === "wc" ||
                              updateOrder.status === "success" ||
                              updateOrder.status === "cancel"
                            }
                            control={
                              <Radio
                                sx={{
                                  fontSize: font.size.md,
                                  color: "var(--primary-color)",
                                  "&.Mui-checked": {
                                    color: "var(--primary-color)",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: 22,
                                  },
                                }}
                              />
                            }
                            label="ใช้ขนส่ง Lalamove"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Stack>
                  )}

                {orderDetail.status !== "delivery" &&
                  orderDetail.status !== "wc" &&
                  orderDetail.status !== "success" &&
                  orderDetail.status !== "cancel" && (
                    <WrapperDeliveryDetail>
                      {deliveryType === "LALAMOVE" &&
                        !!!orderDetail?.delivery_detail_group
                          ?.delivery_ref_code && (
                          <Button
                            onClick={() => {
                              openState(`seller-order.get-quotation-sheet`);
                            }}
                            variant="secondary"
                            startIcon={<LocalShippingIcon />}
                            sx={{ width: "max-content", alignSelf: "center" }}
                          >
                            เรียกรถเข้ารับสินค้า
                          </Button>
                        )}

                      {deliveryType === "By seller" && (
                        <>
                          <WrapperAttachSlip>
                            <SpanAttachSlip>แนบหลักฐานการส่งของ</SpanAttachSlip>

                            {checkNotEmpty(
                              updateOrder?.delivery_sending_image,
                            ) && (
                              <IconButton
                                sx={{
                                  padding: "3px",
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  zIndex: 10,
                                  backgroundColor: "#d9d9d999",
                                  ":hover": {
                                    backgroundColor: "#d9d9d9db",
                                  },
                                }}
                                onClick={() => {
                                  const dataUp = updateOrder;
                                  dataUp.delivery_sending_image = "";
                                  setUpdateOrder({ ...dataUp });
                                }}
                              >
                                <CloseIcon
                                  sx={{
                                    color: "#e04132",
                                    cursor: "pointer",
                                  }}
                                />
                              </IconButton>
                            )}

                            <UploadImage
                              callBackFile={(fileCallBlack) => {
                                const dataUp = updateOrder;
                                dataUp.delivery_sending_image = fileCallBlack;
                                fileCallBlack !== "" &&
                                  setUpdateOrder({ ...dataUp });
                              }}
                              closeAlert={false}
                            >
                              {checkNotEmpty(
                                updateOrder?.delivery_sending_image,
                              ) ? (
                                <WrapperUploadImage>
                                  <WrapperImgSlip>
                                    <ImgSlip
                                      src={
                                        updateOrder?.delivery_sending_image
                                          ?.fileData
                                      }
                                      alt="delivery_sending_image"
                                    />
                                  </WrapperImgSlip>
                                </WrapperUploadImage>
                              ) : (
                                <WrapperUploadImage>
                                  <Button
                                    sx={{
                                      padding: "8px 16px",
                                      fontSize: "0.875rem",
                                      "&.MuiButton-outlined": {
                                        border: "1px solid #d9d9d9",
                                      },
                                    }}
                                    variant="outlined"
                                    startIcon={<AddCircleIcon />}
                                  >
                                    {getLocale() === "th"
                                      ? "แนบหลักฐานการส่งของ"
                                      : "Attach proof of delivery"}
                                  </Button>
                                </WrapperUploadImage>
                              )}
                            </UploadImage>
                          </WrapperAttachSlip>

                          <WrapperConfirmButton>
                            <Button
                              disabled={
                                !checkNotEmpty(
                                  updateOrder?.delivery_sending_image,
                                )
                              }
                              onClick={() =>
                                openDialog({
                                  type: "confirm",
                                  title: `หากกดยืนยันแล้วจะไม่สามารถกลับมาแก้ไข\nหลักฐานการส่งของได้อีก`,
                                  onConfirm: () => {
                                    handleUpdate();
                                  },
                                  maxWidth: 400,
                                })
                              }
                              sx={{
                                borderRadius: "50px",
                                textAlign: "center",
                                padding: {
                                  md: "12px 40px",
                                  xs: "8px 16px",
                                },
                                minWidth: {
                                  md: "160px",
                                  xs: "140px",
                                },
                                fontSize: "1rem",
                              }}
                              variant="contained"
                            >
                              {getLocale() === "th" ? "บันทึก" : "Save"}
                            </Button>
                          </WrapperConfirmButton>
                        </>
                      )}
                    </WrapperDeliveryDetail>
                  )}

                {(orderDetail.status === "delivery" ||
                  orderDetail.status === "wc" ||
                  orderDetail.status === "success") && (
                  <>
                    {!!orderDetail?.delivery_detail_group
                      ?.delivery_sending_image && (
                      <WrapperDeliveryDetail>
                        <WrapperAttachSlip>
                          <SpanAttachSlip>หลักฐานการส่งของ</SpanAttachSlip>

                          <WrapperUploadImage>
                            <WrapperImgSlip>
                              <ImgSlip
                                src={
                                  orderDetail?.delivery_detail_group
                                    ?.delivery_sending_image
                                }
                                alt="delivery_sending_image"
                              />
                            </WrapperImgSlip>
                          </WrapperUploadImage>
                        </WrapperAttachSlip>
                      </WrapperDeliveryDetail>
                    )}
                  </>
                )}
              </DivBackground>
            </Grid>
          </Grid>
        </Container>
      </Main>

      <GetQuotationDialog
        userType="seller"
        orderDetail={orderDetail}
        productList={orderDetail?.product_choice_orders}
        isOpen={getModalState(`seller-order.get-quotation-sheet`)?.isOpen}
        onClose={() => close(`seller-order.get-quotation-sheet`)}
        onSuccess={() => {
          close(`seller-order.get-quotation-sheet`);
          fetchOrderDetail();
          closeAllDialogs();
        }}
      />

      {isLoading && <Loading />}
    </>
  );
}

export default SellerOrderDetail;
